// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: var(--planeed-color-white);
}

ion-popover {
  --backdrop-opacity: 0;
  --box-shadow: none;
}
ion-popover ion-item {
  --ion-background-color: var(--planeed-color-white);
  color: #000;
}

ion-card {
  border-radius: 0;
  background: var(--planeed-color-white);
  margin: 2.5rem 0 0 0;
}
@media only screen and (min-width: 460px) {
  ion-card {
    border-radius: 10px;
    margin-top: 0;
  }
}

ion-card-content {
  --padding-start: 10px;
  --padding-end: 10px;
  padding-inline-start: 10px;
  padding-inline-end: 10px;
  padding-bottom: 0;
}

.item-header {
  background-color: var(--planeed-color-white);
  color: var(--ion-color-secondary);
}

.item-header-colored {
  background-color: var(--ion-color-secondary) !important;
  color: var(--planeed-color-white) !important;
}

.avatar-icon {
  position: absolute;
  z-index: 6;
  margin-left: 4px;
  object-fit: cover;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  background-color: var(--planeed-color-white);
}
.avatar-icon:hover {
  cursor: pointer;
}

.item-header h2 {
  margin: 0 0 2px 5px !important;
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
}
@media only screen and (min-width: 460px) {
  .item-header h2 {
    padding-top: 5px;
    padding-bottom: 5px;
  }
}
@media only screen and (min-width: 1450px) {
  .item-header h2 {
    font-size: 16px !important;
    margin: 0 0 2px 0 !important;
  }
}

.item-header p {
  font-size: 10px;
  margin: 0 0 0 5px !important;
}
@media only screen and (min-width: 460px) {
  .item-header p {
    font-size: 12px !important;
  }
}
@media only screen and (min-width: 1450px) {
  .item-header p {
    font-size: 14px !important;
    margin: 0 0 2px 0 !important;
  }
}

.content-image {
  z-index: 1;
  position: relative;
  overflow: hidden;
  height: 100%;
}

.content-image img {
  width: 100%;
}
.content-image img:hover {
  cursor: pointer;
}

.social-counter-ap {
  --ion-grid-columns: 5;
  border-bottom: 1px solid var(--planeed-color-lightgrey);
  margin-bottom: 8px;
  color: var(--ion-color-medium);
  padding: 8px 0px;
  display: flex;
  justify-content: space-between;
}
.social-counter-ap ion-col {
  text-align: center;
}
.social-counter-ap span {
  margin-left: 5px;
  vertical-align: top;
}

.social-counter {
  --ion-grid-columns: 5;
  border-bottom: 1px solid var(--planeed-color-lightgrey);
  margin-bottom: 8px;
  color: var(--ion-color-medium);
  padding: 8px 0px;
  display: flex;
}
.social-counter ion-col {
  text-align: center;
}
.social-counter span {
  margin-left: 5px;
}

ion-card-content h2 {
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  color: var(--ion-color-text-color);
}

button {
  background: var(--planeed-color-white);
  color: var(--ion-color-secondary);
}

.skeleton {
  width: 100%;
  height: 200px;
}

ion-item {
  padding: 0;
  margin: 0;
  background: var(--planeed-color-white);
  border-radius: 0;
}

.item-header {
  background-color: var(--planeed-color-white);
  color: var(--ion-color-secondary);
}

.item-header-colored {
  background-color: var(--planeed-color-white);
  color: var(--ion-color-secondary);
}

.item-header h2 {
  margin: 0;
  font-size: 15px;
}

.item-header p {
  margin: 0;
  font-size: 12px;
}

.post-content-image {
  width: 100%;
  z-index: 1;
  position: relative;
}

.post-content-image img {
  object-fit: cover;
  object-position: center center;
  cursor: pointer;
  width: 100%;
}

button {
  background: var(--planeed-color-white);
  color: var(--ion-color-secondary);
}

.skeleton {
  width: 100%;
  height: 200px;
}

.spaceBetween {
  --ion-grid-columns: 5;
  justify-content: space-between;
}

.icon-row {
  --ion-grid-columns: 5;
}

.card-btn {
  text-align: center;
  margin-bottom: 0;
}
.card-btn ion-col {
  text-align: center;
}
.card-btn div {
  font-size: 10px;
  font-weight: normal;
}
.card-btn ion-icon {
  font-size: 22px;
  height: 22px;
  margin-top: 2px;
  margin-bottom: 6px;
}
.card-btn ion-button {
  --padding-start: 0px;
  --padding-end: 0px;
}
.card-btn .greyText {
  color: #888;
}

.comments-text {
  font-size: 12px;
  color: var(--ion-color-secondary);
  text-align: right;
  text-decoration: underline;
  padding-right: 10px;
}

@media only screen and (min-width: 460px) {
  ion-footer {
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
  }
}

.menu-popover {
  --width: 204px !important;
  margin-left: -7px;
  --background: transparent;
}
.menu-popover ion-list {
  padding: 5px 0;
  margin: 0;
  border: 2px var(--ion-color-secondary) solid;
  width: 200px;
  align-self: end;
  border-radius: 10px;
}
@media only screen and (min-width: 460px) {
  .menu-popover ion-list {
    border-radius: 10px;
    margin: 0 0 50px;
  }
}
.menu-popover ion-icon {
  font-size: 17px;
  margin: 0;
  padding: 0;
}
.menu-popover ion-label {
  padding: 0;
  margin: 0;
  color: var(--ion-color-secondary);
  font-size: 12px;
}
.menu-popover ion-item {
  padding: 0 20px;
  margin: 0;
  line-height: 40px;
}
.menu-popover ion-item::part(native) {
  min-height: 30px;
  font-size: 12px;
}
.menu-popover ion-item:last-child {
  --border-width: 0 0 0 0 !important;
  --inner-border-width: 0 0 0 0 !important;
}

.menu-box {
  text-align: center;
  justify-content: right;
  display: flex;
  align-items: center;
  font-size: 17px;
  margin: 0;
  padding: 0;
  float: right;
}

.thumb_img {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  margin-right: 10px;
  object-fit: cover;
}

.comments-box {
  --ion-background-color: var(--planeed-color-white);
}
.comments-box ion-item {
  margin: 10px 10px;
}
.comments-box ion-icon {
  font-size: 17px;
  margin-left: 5px;
}

textarea {
  border-radius: 5px !important;
  background-color: var(--planeed-color-white) !important;
  padding: 14px 20px !important;
  font-size: 12px !important;
  z-index: 1 !important;
  margin-left: 2px;
  margin-top: 2px;
  margin-bottom: 2px;
  border: 1px solid var(--ion-color-tertiary-opacity);
}

.comment-form {
  display: inherit;
}

.comment-form button {
  background: none;
}

ion-button {
  color: var(--ion-color-secondary);
  text-transform: capitalize;
  margin-right: 10px;
}

ion-item {
  --padding-start: 0px !important;
  --padding-end: 0px !important;
  --inner-padding-start: 0px !important;
  --inner-padding-end: 0px !important;
}

.comment-btn {
  --padding-start: 5px;
  --padding-end: 5px;
}

.sticky-comment-box {
  padding: 0 5px 5px 10px;
  background: var(--planeed-color-white) !important;
}

.avatar-box {
  height: 100%;
  padding-top: 16px;
}

.post-icon {
  position: relative;
  margin-left: 1px;
}

.post-tagline {
  display: flex;
  align-items: center;
  font-size: 12px !important;
  cursor: pointer;
}

.comment-reply {
  margin-left: 30px !important;
}

.comment-buttons {
  color: var(--ion-color-medium);
  font-size: 12px;
  margin: 0;
  padding: 0;
}
.comment-buttons ion-icon {
  font-size: 12px;
  position: relative;
  margin-top: 3px;
}

.comment-buttons span {
  margin: 0 12px 0 0;
}

.translate-cls {
  color: #888;
  text-align: right;
  margin-top: 0px;
  font-size: 12px;
}
.translate-cls:hover {
  cursor: pointer;
}

.rating-box {
  border: var(--ion-color-secondary) 1px solid;
  border-radius: 30px;
  background: var(--planeed-color-white);
  padding-top: 3px;
}
.rating-box ion-col {
  text-align: center;
}

ul.tags_list {
  list-style-type: disc;
  margin: 5px;
  padding: 0;
}

ul.tags_list li {
  float: left;
  margin: 0;
  padding: 0;
  margin-right: 10px;
  margin-left: 13px;
  font-size: 13px;
  color: darkgray;
}

.author-details {
  margin-left: 10px;
  border-bottom: 1px solid #eee;
  width: 90%;
}

.author-details p {
  margin: 0;
  padding: 0;
}

.author-details img {
  width: 40px;
  height: 40px;
}

.product-info h2 {
  text-align: center;
  width: 100%;
  background-color: var(--planeed-color-lightgrey);
  color: #676767;
  margin: 0;
  padding: 10px;
  font-size: 15px;
  border-top: 1px #ddd solid;
  border-bottom: 1px #ddd solid;
}

.comment-input-box {
  width: 100%;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 10px;
  height: 100%;
}

.sdgs-box {
  border-radius: 3px;
  padding: 0 5px;
  height: 35px;
}
.sdgs-box img {
  max-height: 35px;
}

.sdgs-header {
  height: 30px;
}

.sdgs-content {
  font-size: 11px;
  text-align: right;
  line-height: 14px;
}

.sdgs-title {
  color: var(--ion-color-text-color);
  font-size: 12px;
}

.sdgs-box-dark {
  background: var(--ion-color-secondary);
  color: #fff;
}

.text-content {
  font-size: 14px;
  font-weight: 300;
  line-height: 21px;
  color: #363636;
  -webkit-user-select: text;
  user-select: text;
}

.link {
  color: var(--ion-color-warning);
  font-weight: bold;
  text-transform: capitalize;
}

.metric-text {
  display: flex;
  align-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 300;
  color: var(--ion-color-secondary);
  border-bottom: 1px solid var(--planeed-color-lightgrey);
  border-top: 1px solid var(--planeed-color-lightgrey);
  padding: 10px 0;
}
.metric-text .number {
  color: var(--ion-color-warning);
}
.metric-text .metric-icon {
  display: inline-block;
  align-items: center;
  height: 24px;
  width: 24px;
  margin: auto 7px auto 0px;
  fill: var(--ion-color-secondary);
}

.SDGsBox {
  margin-top: 20px;
  border-bottom: 1px solid var(--planeed-color-lightgrey);
  padding-bottom: 15px;
}

ion-grid {
  --ion-grid-columns: 4;
}

.primary-btn {
  margin: 0;
}

.swiper-container {
  position: relative;
}

.swiper-button-next, .swiper-button-prev {
  position: absolute;
  top: 50%;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: var(--swiper-nav-button-background);
  opacity: 50%;
  color: var(--swiper-nav-button-color);
  z-index: 10;
}

.swiper-button-next::after, .swiper-button-prev::after {
  font-size: 15px;
}

.swiper-pagination {
  position: absolute;
  top: calc(100% + 10px);
}

:host ::ng-deep .swiper-pagination-bullet {
  background-color: var(--ion-color-secondary);
}

:host ::ng-deep .swiper-pagination-bullet-active {
  background-color: var(--ion-color-secondary-tint);
}

@media only screen and (min-width: 460px) {
  .app-post-card {
    background-color: var(--planeed-color-white);
    border-radius: 10px;
  }
}

.bottom-container {
  display: flex;
  flex-direction: column;
  background-color: var(--planeed-color-white);
  margin-bottom: 1rem;
}

.moments-headline {
  background-color: var(--planeed-color-white);
  text-align: center;
  padding: 10px 0 10px 0;
  border-top: 1px solid var(--planeed-color-lightgrey);
  color: var(--ion-color-secondary);
  position: sticky;
  top: 0;
}

.moment-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2px;
  background-color: var(--planeed-color-white);
  height: 100%;
}

.moment-item {
  width: 100%;
}

.moment-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  object-position: center center;
  display: block;
  cursor: pointer;
}
@media only screen and (max-width: 460px) {
  .moment-image {
    height: 160px;
  }
}

.comment-input-box-modal {
  width: 100%;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 10px;
  margin-top: 2rem;
}

.comment-box-modal {
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding-top: 2rem;
}

ion-modal::part(content) {
  height: 100% !important;
  display: flex;
  flex-direction: column;
}

ion-content {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.comments-scrollable {
  flex: 1;
  overflow-y: auto;
  max-height: calc(100vh - 200px);
}

ion-item {
  --background: var(--planeed-color-white);
}

.moment-content {
  border-radius: 10px;
}

ion-modal {
  --border-radius: 10px;
  --height: auto;
}

.bottom-content {
  --background: var(--planeed-color-white) !important ;
}

.browser-comment-container {
  max-height: 350px;
  overflow-y: auto;
}

@media only screen and (min-width: 460px) {
  .moment-images-container {
    min-height: 650px;
    overflow-y: auto;
    margin-bottom: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
}

ion-item {
  --border-color: var(--planeed-color-white);
  margin-top: 2rem;
  margin-left: 10px;
}

.card-content {
  cursor: pointer;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
